"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
/**
 * FacebookLoginButton - Uses Meta's official JavaScript SDK for authentication
 * Replaces the deprecated react-facebook-login package.
 *
 * The Meta SDK is loaded via CDN and provides the FB.login() method for authentication.
 * This component maintains the same callback interface as the original react-facebook-login,
 * so parent components can be updated with minimal changes.
 */
const FacebookLoginButton = ({
  appId,
  scope,
  callback,
  render
}) => {
  const [sdkReady, setSdkReady] = _react.default.useState(false);
  (0, _react.useEffect)(() => {
    // Check if SDK is already loaded
    if (window.FB) {
      setSdkReady(true);
      return;
    }

    // Load Meta's Facebook SDK
    const script = document.createElement('script');
    script.async = true;
    script.defer = true;
    script.crossOrigin = 'anonymous';
    script.src = 'https://connect.facebook.net/en_US/sdk.js';
    script.onload = () => {
      // Initialize the SDK
      window.FB.init({
        appId,
        xfbml: false,
        version: 'v25.0',
        // Use same version as backend
        cookie: true,
        status: true
      });
      setSdkReady(true);
    };
    document.body.appendChild(script);
    return () => {
      // Cleanup: remove script on unmount if needed
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, [appId]);
  const handleClick = () => {
    if (!window.FB) {
      console.error('Facebook SDK not loaded');
      return;
    }

    // Parse scopes (can be comma or space separated)
    const scopes = Array.isArray(scope) ? scope : scope.split(/[,\s]+/).filter(Boolean);
    window.FB.login(response => {
      // Transform FB response to match react-facebook-login format
      const transformedResponse = {
        accessToken: response.authResponse?.accessToken || null,
        userID: response.authResponse?.userID || null,
        expiresIn: response.authResponse?.expiresIn || null,
        signedRequest: response.authResponse?.signedRequest || null,
        graphDomain: response.authResponse?.graphDomain || 'facebook',
        status: response.status
      };
      callback(transformedResponse);
    }, {
      scope: scopes.join(','),
      auth_type: 'rerequest'
    });
  };

  // Render prop pattern: pass handleClick as onClick to the render function
  return render && sdkReady ? render({
    onClick: handleClick
  }) : null;
};
FacebookLoginButton.propTypes = {
  appId: _propTypes.default.string.isRequired,
  scope: _propTypes.default.string,
  callback: _propTypes.default.func.isRequired,
  render: _propTypes.default.func.isRequired
};
FacebookLoginButton.defaultProps = {
  scope: 'public_profile,email'
};
var _default = exports.default = FacebookLoginButton;